import { t } from "ttag";

import { BILLING_FREQUENCY } from "@/shared/domains";
import type { Price } from "@/shared/domains";

export const formatFullName = (fullName: string) => {
  const words = fullName.trim().split(/\s+/);
  const initial = words[0]?.[0]?.toUpperCase() + ".";
  const rest = words.slice(1).join(" ");

  return words.length > 1 ? `${initial} ${rest}` : initial || "";
};

const MONTH_TO_DAYS_MULTIPLIER = 28 as const;

export const getBillingFrequencyVerbose = (
  frequency: Price["durationInMonths"],
) => {
  const daysText = `${MONTH_TO_DAYS_MULTIPLIER * frequency} ${t`days`}`;
  const monthsText = `${frequency} ${t`months`}`;

  return frequency <= BILLING_FREQUENCY.QUARTERLY ? daysText : monthsText;
};
